var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _line, _line2, _line3, _line4, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeInBag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 104,
    viewBox: "0 0 67 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.7904C0.5 13.8864 2.04358 12.3428 3.94767 12.3428H62.1758C64.0799 12.3428 65.6235 13.8863 65.6235 15.7904V103.126H0.5V15.7904Z",
    fill: "white",
    stroke: "#004137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27344 38.1479V47.9961V49.403L65.4895 83.2899L64.8537 71.2097L1.27344 38.1479Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27344 62.3081V72.1563V73.5632L55.9524 102.364H65.4895V96.0056L1.27344 62.3081Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97576 13.8169L1.03125 23.7023V25.1145L65.49 59.1295L64.8518 47.0036L1.97576 13.8169Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.27641
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0669 13.9879H41.5546L65.215 24.5728V35.1921L24.5736 13.9879H27.0669Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6358 95V86.071L31.5066 102.364H13.835L1.6358 96.5973V95Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.988281 15.7908C0.988281 14.1557 2.31386 12.8301 3.94903 12.8301H62.1772C63.8123 12.8301 65.1379 14.1557 65.1379 15.7908V29.6077H0.988281V15.7908Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.4405,
    y: 43.8702,
    width: 31.7901,
    height: 41.963,
    rx: 1.90741,
    fill: "white",
    stroke: "#004137",
    strokeWidth: 1.2716,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.6172,
    y1: 52.7714,
    x2: 45.7777,
    y2: 52.7714,
    stroke: "black",
    strokeWidth: 1.2716
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6172,
    y1: 59.1293,
    x2: 45.7777,
    y2: 59.1293,
    stroke: "black",
    strokeWidth: 1.2716
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6172,
    y1: 65.4877,
    x2: 45.7777,
    y2: 65.4877,
    stroke: "black",
    strokeWidth: 1.2716
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6172,
    y1: 71.8456,
    x2: 45.7777,
    y2: 71.8456,
    stroke: "black",
    strokeWidth: 1.2716
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 75.0703L27.9727 75.0703L27.9727 82.5512L28.4434 82.5512L28.4434 75.0703Z",
    fill: "#004137"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9697 75.0703L28.7344 75.0703L28.7344 82.5512L28.9697 82.5512L28.9697 75.0703Z",
    fill: "#004137"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7393 75.0703L29.5039 75.0703L29.5039 82.5512L29.7393 82.5512L29.7393 75.0703Z",
    fill: "#004137"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.001 75.0703L30.7656 75.0703L30.7656 82.5512L31.001 82.5512L31.001 75.0703Z",
    fill: "#004137"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.001 75.0703L31.7656 75.0703L31.7656 82.5512L32.001 82.5512L32.001 75.0703Z",
    fill: "#004137"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2676 75.0244L32.7969 75.0244L32.7969 82.5053L33.2676 82.5053L33.2676 75.0244Z",
    fill: "#004137"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8252 75.0703L33.5898 75.0703L33.5898 82.5512L33.8252 82.5512L33.8252 75.0703Z",
    fill: "#004137"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3019 75.0244L34.5664 75.0244L34.5664 82.5053L35.3019 82.5053L35.3019 75.0244Z",
    fill: "#004137"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5947 75.0703L36.3594 75.0703L36.3594 82.5512L36.5947 82.5512L36.5947 75.0703Z",
    fill: "#004137"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0606 75.0703L35.5898 75.0703L35.5898 82.5512L36.0606 82.5512L36.0606 75.0703Z",
    fill: "#004137"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5949 75.0703L36.8594 75.0703L36.8594 82.5512L37.5949 82.5512L37.5949 75.0703Z",
    fill: "#004137"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8574 75.0703L38.3867 75.0703L38.3867 82.5512L38.8574 82.5512L38.8574 75.0703Z",
    fill: "#004137"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4189 75.0703L39.1836 75.0703L39.1836 82.5512L39.4189 82.5512L39.4189 75.0703Z",
    fill: "#004137"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.988281 29.6074H65.1379",
    stroke: "#004137",
    strokeWidth: 1.2716
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeInBag);
export default __webpack_public_path__ + "static/media/tube-in-bag.4b536965a71d940bc73c81becf7c87fd.svg";
export { ForwardRef as ReactComponent };